/*
  Zugo - marka vitrini seridi.

  Swiper yerine tarayicinin kendi kaydirmasi kullanilir (`scroll-snap`):
  dokunmatikte zaten dogru calisir, oklar ve noktalar sadece o kaydirmayi
  tetikler. Sayfa sayisi ekran genisligine gore degistigi icin (mobilde 2,
  masaustunde 4 urun gorunur) noktalar olcumle uretilir, sabit sayilmaz.
*/
class ZugoBrandSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.dots = this.querySelector('[data-dots]');
    this.items = [...this.querySelectorAll('[data-item]')];
    this.arrows = [...(this.closest('.zugo-brand-col')?.querySelectorAll('[data-yon]') || [])];

    if (!this.track || this.items.length === 0) return;

    this.onScroll = this.debounce(() => this.durumGuncelle(), 90);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });

    this.arrows.forEach((btn) =>
      btn.addEventListener('click', () => this.kaydir(btn.dataset.yon === 'sonraki' ? 1 : -1))
    );

    if (window.ResizeObserver) {
      this.observer = new ResizeObserver(this.debounce(() => this.noktalariKur(), 120));
      this.observer.observe(this.track);
    }

    this.noktalariKur();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.track?.removeEventListener('scroll', this.onScroll);
  }

  get sayfaGenisligi() {
    return this.track.clientWidth;
  }

  get sayfaSayisi() {
    // Tam bir ekran dolusu kaydirilabilir alan yoksa tek sayfa demektir.
    return Math.max(1, Math.round(this.track.scrollWidth / this.sayfaGenisligi));
  }

  get aktifSayfa() {
    return Math.round(this.track.scrollLeft / this.sayfaGenisligi);
  }

  noktalariKur() {
    if (!this.dots) return;
    const adet = this.sayfaSayisi;

    if (adet < 2) {
      this.dots.innerHTML = '';
      this.arrows.forEach((b) => (b.disabled = true));
      return;
    }

    if (this.dots.children.length !== adet) {
      this.dots.innerHTML = '';
      for (let i = 0; i < adet; i += 1) {
        const nokta = document.createElement('button');
        nokta.type = 'button';
        nokta.className = 'zugo-brand-col__dot';
        nokta.setAttribute('aria-label', `${i + 1}`);
        nokta.addEventListener('click', () => {
          this.track.scrollTo({ left: i * this.sayfaGenisligi, behavior: 'smooth' });
        });
        this.dots.appendChild(nokta);
      }
    }

    this.durumGuncelle();
  }

  durumGuncelle() {
    const aktif = this.aktifSayfa;
    [...this.dots.children].forEach((d, i) =>
      d.setAttribute('aria-current', i === aktif ? 'true' : 'false')
    );

    const son = this.sayfaSayisi - 1;
    this.arrows.forEach((b) => {
      b.disabled = b.dataset.yon === 'sonraki' ? aktif >= son : aktif <= 0;
    });
  }

  kaydir(yon) {
    this.track.scrollBy({ left: yon * this.sayfaGenisligi, behavior: 'smooth' });
  }

  debounce(fn, ms) {
    let t;
    return (...a) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, a), ms);
    };
  }
}

if (!customElements.get('zugo-brand-slider')) {
  customElements.define('zugo-brand-slider', ZugoBrandSlider);
}
